import Skeleton from "react-loading-skeleton";
import { VoiceDeviceCard } from ".";
import cn from "classnames";
import { devicesLoaded } from "../../redux/devices-slice";
import { oemValues } from "../../constants/oem";
import styles from "./VoiceDevicesList.module.scss";
import { useSelector } from "react-redux";

export function VoiceDevicesList({ devices = [], className }) {
  const success = useSelector(devicesLoaded);

  const SKELETONS_DEVICE_COUNT = 4;
  const skeletons = Array(SKELETONS_DEVICE_COUNT)
    .fill()
    .map((_, idx) => <Skeleton key={idx} className={styles.skeleton} />);

  function listDevices(devices) {
    const voiceCompatibleDevices = devices.filter((device) => {
      return oemValues.voiceCompatible.includes(device.model);
    });
    return voiceCompatibleDevices.map((device) => (
      <VoiceDeviceCard device={device} key={device.cloudId} />
    ));
  }

  return (
    <div className={cn(styles.devicesList, className)}>
      {success ? listDevices(devices) : skeletons}
    </div>
  );
}
